// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreCustomerFeedback = (client) => ({
    /**
     * `POST /store/customer-feedback`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomerFeedbackCreate
     * @source apps/backend/src/api/store/customer-feedback/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/customer-feedback", { method: "POST", body, query, headers }),
    /**
     * `POST /store/customer-feedback/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomerFeedbackIdCreate
     * @source apps/backend/src/api/store/customer-feedback/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/store/customer-feedback/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=customer-feedback.js.map